import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import check from "../images/check.png";
import { decryptData } from "../Services/TabServices";

interface DoctorAppointmentSlotsProps{
  doctor: any;
  appointmentId:any
  emailId:any
  email:any
  doctorFees:any
  doctorName:string
  patientName:string
  patientId:any
  onCloseModal: () => void; 
}
const DoctorAppointmentSlot: React.FC<DoctorAppointmentSlotsProps> = ({doctor,appointmentId,emailId, email, doctorFees,patientId ,doctorName,patientName,onCloseModal}) => {
  const doctorId = typeof doctor === "string" ? Number(doctor) : doctor;
  const navigate = useNavigate();
  const token = sessionStorage.getItem("token");
  const id =String(sessionStorage.getItem("userId"))
  const crmID = parseInt(sessionStorage.getItem("userId") || "", 10);
  const decryptedCrmId=decryptData(id);
  const [doctorDetail, setDoctorDetail] = useState<any>([]);
  const [selectedOption, setSelectedOption] = useState<any>("video");
  const [selectedDate, setSelectedDate] = useState<string | null>(null);
  const [selectedDay, setSelectedDay] = useState<any>(null);
  const [selectedSlot, setSelectedSlot] = useState<any | null>(null);
  const [selectedSlotEndTime, setSelectedEndTimeSlot] = useState<any | null>(null);
  const [EndselectedSlotTime, setSelectedEndSlotTime] = useState<any | null>(null);
  const [selectedSlotId, setSelectedSlotId] = useState<any | null>(null);
  const [nextSevenDays, setNextSevenDays] = useState<{ date: string; day: string }[]>([]);
  const [doctorAvailability, setDoctorAvailability] = useState<any>(null);
  const [checkoutPage, setCheckoutPage] = useState<boolean>(true);
  const [error, setError] = useState<string>("");
  const [slotError, setSlotError] = useState<string>("");
  const [slot, setSlots] = useState<any>([]);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
const [appointmentStatus, setAppointmentStatus] = useState("pending"); 
const [loading, setLoading] = useState(false);
// State for reschedule reason + remark
const [rescheduleReason, setRescheduleReason] = useState("");
const [rescheduleRemark, setRescheduleRemark] = useState("");


 const fetchDoctorAvailability = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/Patient/GetDoctorAvailability`
        );
        const data = response.data;
        const foundDoctor =data.find((doc: any) => doc.doctorId === doctorId);
        setDoctorAvailability(foundDoctor);
      } catch (err) {
        console.error("Error fetching doctor availability:", err);
      }
    };
  useEffect(() => {
   
    fetchDoctorAvailability();
  }, [doctorId]);

  
  useEffect(() => {
    const getNextSevenDays=(): { date: string; day: string }[] => {
      const daysArray: { date: string; day: string }[]=[];
      const options: Intl.DateTimeFormatOptions = { weekday:"long"};
      for (let i = 0; i < 7; i++){
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate() + i);
        daysArray.push({
          date: currentDate.toISOString().split("T")[0],
          day: new Intl.DateTimeFormat("en-US", options)
            .format(currentDate)
            .slice(0, 3),
        });
      }
      return daysArray;
    };
    const days = getNextSevenDays();
    setNextSevenDays(days);
    const firstAvailableDay = days.find((day) => isDayAvailable(day.day));
    if (firstAvailableDay) {
      setSelectedDate(firstAvailableDay.date);
    }
  }, [doctorAvailability]);

  const isDayAvailable = (day: string) => {
    if (!doctorAvailability) return false;

    const dayMapping: { [key: string]: string } = {
      Mon: "monday",
      Tue: "tuesday",
      Wed: "wednesday",
      Thu: "thursday",
      Fri: "friday",
      Sat: "saturday",
      Sun: "sunday",
    };
    return doctorAvailability[dayMapping[day]] === "Available";
  };
 useEffect(() => {
    if (!selectedSlotId || !selectedDate) return;
    const availabilitySlotPatient = async () => {
      setError("");
      try {
        const response: any = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/Patient/CheckAppointmentAvailabilityNew`,
          {
            headers:{
              Authorization: `Bearer ${token}`,
            },
            params:{
              PatientId: patientId,
              DoctorId: doctorId,
              SlotId: selectedSlotId,
              GivenDate: selectedDate,
            },
          }
        );
        setCheckoutPage(true);
      }catch (error: any){
        if (error.response && error.response.status === 409) {
          setError(
            "You already have an appointment with another doctor at this time."
          );
          setCheckoutPage(false);
        }
        else
        {
          console.error(
            "Error in getting slot availability for patient",
            error
          );
        }
      }
    };
    availabilitySlotPatient();
  }, [selectedSlotId]);

  const isSlotInFuture = (slotStartTime: string, date: string): boolean => {
    const now = new Date();
    const slotDateTime = new Date(`${date}T${slotStartTime}`);
    return (slotDateTime.getTime() - now.getTime()) >= 10 * 60 * 1000; // 10 mins
  };


 useEffect(() => {
    if (!selectedDate) return;
    setSlots([]);
    setError("");
    const getDoctorSlots = async () => {
      try {
        const res: any = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/Patient/GetDoctorSlotStatus`,
          {
            params: { doctorId, Date: selectedDate },
          }
        );
        const slots = res?.data || [];
        setSlots(res?.data);
        if (slots.length>0){
          const availableSlots =slots.find((slot: any) =>{
            return (
              slot.status !== "Booked" && slot.status!=="Unavailable"&&
              isSlotInFuture(slot.slotStartTime,selectedDate)
            );
          });
          if(availableSlots){
            setSelectedSlot(availableSlots.slotStartTime);
                setSelectedEndTimeSlot(availableSlots.slotEndTime); 

            setSelectedSlotId(availableSlots.slotId);
          }else{
            setSelectedSlot(null);
                setSelectedEndTimeSlot(null);
            setSelectedSlotId(null);
          }
        }
      }catch(err: any){
        console.error("GetDoctorSlot API error:", err);
        if (err.status === 404){
          setSlotError(err?.response?.data);
        }
      }
    };
    getDoctorSlots();
  }, [doctorId, selectedDate]);

  const generateTimeSlots = (
    startTime: string,
    endTime: string,
    interval: number
  ) => 
    {
    const slots = [];
    let current = new Date();
    const [startHour, startMin] = startTime.split(":").map(Number);
    const [endHour, endMin] = endTime.split(":").map(Number);
    current.setHours(startHour, startMin, 0, 0);
    const endTimeObj = new Date();
    endTimeObj.setHours(endHour, endMin, 0, 0);

    while (current <= endTimeObj) {
      const timeSlot = current.toTimeString().slice(0, 5);// Format HH:MM
      slots.push(timeSlot);
      current.setMinutes(current.getMinutes() + interval); // Increment by interval
    }

    return slots;
  };
  const dummySlots = generateTimeSlots("13:00", "16:30", 30);

  const handleRescheduleAppointment = async (appointmentId: any) => {
  setLoading(true);

  try {
    const date = selectedDate;
    const startDateTime = `${date}T${selectedSlot}`;
    const endDateTime = `${date}T${selectedSlotEndTime}`;
    
  

      const reschedulePayload = {
        appointmentId: appointmentId,
        doctorId: doctor,
        AppointmentDate: selectedDate,
        slotId: selectedSlotId,
        createdBy: decryptedCrmId,
            Reason: rescheduleReason,
        Remark: rescheduleRemark,
      };
      const response: any = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/appointments/RescheduleAppointment`, 
        reschedulePayload,{
          headers: {
            Authorization: `Bearer ${token}`,
          }}
      );
      const newAppointmentId = response.data?.appointmentId;
    
      if (newAppointmentId) {
      
        if (newAppointmentId) {
          setAppointmentStatus("booked");
          setShowConfirmationPopup(true);
          setLoading(false);
          setTimeout(() => {
          setShowConfirmationPopup(false);
          onCloseModal();
          }, 3000);
        }
    }
  } catch (error) {
    console.error("Error in reschedule appointment:", error);
    setLoading(false);
  }
};
  return (
    <div className="flex justify-center w-full">
      {showConfirmationPopup&&(
  <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-40 flex items-center justify-center z-50">
    <div className="flex justify-center items-center p-10">
            <div className="bg-white p-10 ">
              <div className="flex justify-center mb-2">
                <img src={check} alt="" className="text-center w-6 h-6" />
              </div>
              <p className="font-semibold text-lg">
                Your Appointment is Rescheduled!
              </p>
              <p className="text-center text-xs text-[#606060] mt-1">
                Thank you for booking with Rama Hospital
              </p>
            </div>
          </div>
  </div>
)}
      <div className="w-[350px] xs:[400px] sm:w-[400px] md:w-[400px] lg:w-[470px] xl:w-[450px] px-1 xs:px-4 py-2">
        <div className="flex justify-center">
        </div>
        
        <div>
          <p className="text-[14px]  pb-2">Choose Date</p>
          <div className="flex gap-2 xs:gap-2 sm:gap-4">
            {nextSevenDays.map((day, index) => {
              const isAvailable = isDayAvailable(day.day);
              return (
                <div
                  key={index}
                  onClick={() => {
                    if (isAvailable) {
                      setSelectedDate(day.date);
                    }
                  }}
                  style={{
                    backgroundColor:
                      selectedDate === day.date ? "#009A8533" : "white",
                    opacity: isAvailable ? 1 : 0.5,
                    pointerEvents: isAvailable ? "auto" : "none",
                  }}
                  className="w-[45px] h-[55px] border border-[#009A85] rounded-[5px] cursor-pointer"
                >
                  <div className="flex flex-col items-center">
                    <p className="text-[#009A85] text-[14px]">
                      {day.date.slice(8, 10)}
                    </p>
                    <p className="text-[#009A85] text-[14px]">{day.day}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div>
          <p className="text-[14px] pt-4 pb-2">Choose Time</p>
          {slot.length > 0 ? (
            <div className="grid grid-cols-5 xs:grid-cols-5 sm:grid-cols-6 md:grid-cols-6 lg:grid-cols-6 gap-3">
 {slot.map((slotTime: any, index: any) => {
  const isSelected = selectedSlot === slotTime.slotStartTime;
  const isAvailable = slotTime.status === "Available";

  // Disable past slots if the selected date is today
  const today = new Date();
  const slotDateTime = new Date(`${selectedDate}T${slotTime.slotStartTime}`);
  const isPastSlot = slotDateTime < today;

  return (
    <div
      key={index}
      onClick={() => {
        if (isAvailable && !isPastSlot) {
          setSelectedSlot(slotTime.slotStartTime);
          setSelectedEndTimeSlot(slotTime.slotEndTime);
          setSelectedSlotId(slotTime.slotId);
        }
      }}
      style={{
        backgroundColor: isSelected ? "#184A8433" : "white",
        opacity: isAvailable && !isPastSlot ? 1 : 0.5,
        borderColor: isAvailable && !isPastSlot ? "#184A84" : "#ccc",
        color: isAvailable && !isPastSlot ? "#184A84" : "gray",
        pointerEvents: isAvailable && !isPastSlot ? "auto" : "none",
      }}
      className="flex justify-center items-center w-[55px] h-[35px] border rounded-[5px] cursor-pointer"
      title={isPastSlot ? "Past Slot" : slotTime.status}
    >
      <p className="text-sm">{slotTime.slotStartTime.slice(0, 5)}</p>
    </div>
  );
})}

</div>

          ) : (
            (!selectedDate || slotError) && (
              <>
                {/* <p className="flex justify-center text-red-600 text-[10px] mt-2">{slotError}</p> */}
                {/* Dummy Slots */}
                <div className="grid grid-cols-5 xs:grid-cols-5 sm:grid-cols-6 md:grid-cols-6 lg:grid-cols-6 gap-3">
                  {dummySlots.map((slotTime, index) => (
                    <div
                      key={`dummy-${index}`}
                      style={{
                        backgroundColor: "white",
                        opacity: 0.9,
                        borderColor: "#ccc",
                        color: "gray",
                        pointerEvents: "none",
                      }}
                      className="flex justify-center items-center w-[55px] h-[35px] border rounded-[5px] cursor-not-allowed"
                    >
                      <p>{slotTime}</p>
                    </div>
                  ))}
                </div>
              </>
            )
          )}
          {/* Reason + Remark Section */}
<div className="mt-3 space-y-3">
  {/* Reason Dropdown */}
  <div>
    <label className="block text-xs font-medium text-gray-700 mb-1">
      Reason for Reschedule
    </label>
    <select
      value={rescheduleReason}
      onChange={(e) => setRescheduleReason(e.target.value)}
      className="w-full p-1 border rounded text-xs"
    >
      <option value="">Select a reason</option>
      <option value="patient">Rescheduled by Patient</option>
      <option value="doctor">Rescheduled by Doctor</option>
      <option value="other">Other</option>
    </select>
  </div>

  {/* Remark Input */}
  <div>
    <label className="block text-xs font-medium text-gray-700 mb-1">
      Remark
    </label>
    <textarea
      value={rescheduleRemark}
      onChange={(e) => setRescheduleRemark(e.target.value)}
      placeholder="Enter additional details..."
      className="w-full p-1 border rounded text-xs resize-none"
      rows={3}
    />
  </div>
</div>

        </div>
        {error ? (
          <p className=" flex justify-center text-red-600 text-[10px] mt-2">
            {error}
          </p>
        ) : (
          <p className="text-[10px] mt-2">
            Please Choose slot wisely, as per your convenience
          </p>
        )}
        <div className="flex justify-center mt-2">
          <button
            disabled={loading}
 onClick={() => {
    if (!rescheduleReason) {
      setError("Please select a reason before rescheduling.");
      return;
    }
    handleRescheduleAppointment(appointmentId);
  }}            className="bg-[#009A85] text-white px-4 py-2 rounded-lg text-sm text-[14px]"
          >
          {loading ? 'Rescheduling...' : 'Reschedule Appointment '}
          </button>
        </div>

      </div>
    </div>
  );
};

export default DoctorAppointmentSlot;
